import React from 'react';
import { ImageDetails } from '../../data/image-data';

const ImageBox: React.FC<ImageDetails> = ({ preview, fullLink, caption, altText }) => (
   <figure className="flex-grow-0 m-2 w-1/3 h-1/3 cursor-pointer" onClick={() => window.open("images/" + fullLink, "_self")}>
      <img src={"images/" + preview} alt={altText} />
      <figcaption className="text-gray-600 text-center">{caption}</figcaption>
   </figure>
)

export default ImageBox;